import{AIR_PLAY_PLUGIN_ID as r}from"../constants";export var isAirPlayPlugin=function(i){var n;return(null===(n=i.getId)||void 0===n?void 0:n.call(i))===r};